const riot = require('riot');

riot.tag2('module-breadcrumbs', '<div class="f fm"> <div class="flex-fixed f fm ts-hxxs text-gray_60" each="{item,index in opts.items}"><a class="mr4 mr0-last" href="{item.link}">{item.label}</a><span class="mr4" if="{!isLast(index)}">/</span></div> </div>', '', '', function(opts) {

    this.isLast = (index) => {
      return this.opts.items.length - 1 === index;
    };
});